import React from 'react'

interface InvitedUser {
  id: string
  email: string
  name: string
  tempPassword?: string
}

interface InvitedUserConfirmationProps {
  invitedUser: InvitedUser
}

const InvitedUserConfirmation: React.FC<InvitedUserConfirmationProps> = ({ invitedUser }) => {
  return (
    <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
      <h3 className="text-blue-800 font-semibold mb-2">User Invited Successfully!</h3>
      <div className="space-y-2 text-sm text-blue-700">
        <p>
          <strong>Name:</strong> {invitedUser.name}
        </p>
        <p>
          <strong>Email:</strong> {invitedUser.email}
        </p>
        {invitedUser.tempPassword && (
          <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded">
            <p className="text-yellow-800 font-semibold">Temporary Password:</p>
            <p className="text-yellow-800 font-mono text-lg">{invitedUser.tempPassword}</p>
            <p className="text-yellow-700 text-xs mt-1">
              Please send this password to the user via email. They should change it on first login.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default InvitedUserConfirmation
